/* ============================================================
   HEIRBLOOM FLORAL — product.js
   Product page logic: gallery swap, variant selection,
   quantity stepper, add-on price display, AJAX add-to-cart
   with line item properties (card message, add-ons, delivery date).
   ============================================================ */
(function () {
  'use strict';

  const root = document.querySelector('[data-product]');
  if (!root) return;

  const productData = JSON.parse(document.querySelector('[data-product-json]').textContent);

  /* ---------- Gallery thumbnail swap ---------- */
  const mainImage = root.querySelector('[data-main-image]');
  root.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      const src = thumb.getAttribute('data-full');
      if (mainImage && src) mainImage.src = src;
      root.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* ---------- Variant selection ---------- */
  let currentVariant = productData.variants.find(function (v) { return v.available; }) || productData.variants[0];
  const variantIdInput = root.querySelector('[data-variant-id]');
  const priceEl = root.querySelector('[data-product-price]');
  const stickyPriceEl = document.querySelector('[data-sticky-price]');

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function selectVariant(id) {
    currentVariant = productData.variants.find(function (v) { return v.id == id; }) || currentVariant;
    if (variantIdInput) variantIdInput.value = currentVariant.id;
    if (priceEl) priceEl.textContent = money(currentVariant.price);
    if (stickyPriceEl) stickyPriceEl.textContent = money(currentVariant.price);

    const atcBtns = root.querySelectorAll('[data-atc-button]');
    atcBtns.forEach(function (btn) {
      if (currentVariant.available) {
        btn.disabled = false;
        btn.textContent = window.HeirbloomStrings.addToCart;
      } else {
        btn.disabled = true;
        btn.textContent = 'Sold out';
      }
    });
  }

  root.querySelectorAll('[data-variant-option]').forEach(function (opt) {
    opt.addEventListener('click', function () {
      root.querySelectorAll('[data-variant-option]').forEach(function (o) { o.classList.remove('is-active'); });
      opt.classList.add('is-active');
      selectVariant(opt.getAttribute('data-variant-id'));
    });
  });
  root.querySelectorAll('select[data-variant-select]').forEach(function (sel) {
    sel.addEventListener('change', function () { selectVariant(sel.value); });
  });
  selectVariant(currentVariant.id);

  /* ---------- Quantity stepper ---------- */
  root.querySelectorAll('[data-qty-wrap]').forEach(function (wrap) {
    const input = wrap.querySelector('input');
    wrap.querySelector('[data-qty-minus]').addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    wrap.querySelector('[data-qty-plus]').addEventListener('click', function () {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });

  /* ---------- AJAX add to cart with line item properties ---------- */
  const form = root.querySelector('[data-product-form]');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const btns = root.querySelectorAll('[data-atc-button]');
      btns.forEach(function (b) { b.textContent = window.HeirbloomStrings.addingToCart; b.disabled = true; });

      const properties = {};
      form.querySelectorAll('[data-property]').forEach(function (field) {
        const key = field.getAttribute('data-property');
        if (field.type === 'checkbox') {
          if (field.checked) properties[key] = field.getAttribute('data-property-value') || 'Yes';
        } else if (field.value.trim() !== '') {
          properties[key] = field.value.trim();
        }
      });

      const qtyInput = form.querySelector('[data-main-qty]');
      const body = {
        items: [{
          id: currentVariant.id,
          quantity: qtyInput ? parseInt(qtyInput.value, 10) : 1,
          properties: properties
        }]
      };

      fetch(window.HeirbloomRoutes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (window.updateCartCount) window.updateCartCount();
          btns.forEach(function (b) { b.textContent = 'Added ✓'; });
          setTimeout(function () {
            btns.forEach(function (b) { b.textContent = window.HeirbloomStrings.addToCart; b.disabled = false; });
          }, 1800);
        })
        .catch(function () {
          btns.forEach(function (b) { b.textContent = 'Try again'; b.disabled = false; });
        });
    });
  }
})();
